import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=60f41494"
import script from "./Offer.vue?vue&type=script&lang=ts"
export * from "./Offer.vue?vue&type=script&lang=ts"
import style0 from "./Offer.vue?vue&type=style&index=0&id=60f41494&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports